import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

function ActiveLink({
  children,
  href = '',
  activeClassName = 'active',
  className: initialClassName = '',
  exact = false,
  isActive = false,
  'aria-current': ariaCurrent = 'page',
  ...props
}) {
  const exactMatcher = match => match
  const nonExactMatcher = (match, loc) => match || loc.pathname.startsWith(href)
  const router = useRouter()
  const matcher = isActive || (exact ? exactMatcher : nonExactMatcher)
  const isCurrent = matcher(router.pathname === href, router)
  const className = isCurrent
    ? initialClassName + ' ' + activeClassName
    : initialClassName
  const ariaFunc =
    typeof ariaCurrent === 'function' ? ariaCurrent : () => ariaCurrent
  const ariaState = isCurrent ? ariaFunc(router) : undefined
  return (
    <Link href={href} {...props} legacyBehavior>
      {React.cloneElement(React.Children.only(children), {
        className,
        'aria-current': ariaState
      })}
    </Link>
  )
}

export default ActiveLink
